import React from 'react';
import { connect } from 'react-redux';
import FAQ from '../../components/FAQs';

class FAQs extends React.Component {
  render() {
    return <FAQ />
  }
}

export default store =>
  ({
    path: `/faqs`,
    getComponent(next, cb) {
      cb(
        null,
        connect(state => ({ state }),
          dispatch => ({

          }))(FAQs)
      );
    }
  });
